export const enum zIndex {
	DROPDOWNS = 98,
	PANELS = 99,
	MODALS = 100,
	TOASTS = 101,
	TOOLTIPS = 102,
}
